import createPaymentSchemas from "@rentiohq/shared-frontend/dist/forms/createPayment";
import {
  isPerformingSubmitActionSelector,
  performingSubmitActionErrorSelector,
  submitActionCreator,
} from "@rentiohq/shared-frontend/dist/forms/createPayment/schema.createPayment.actions";
import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as brokerHooks from "@rentiohq/shared-frontend/dist/redux/broker/broker.hooks";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { IGeneralLedgerAccount } from "@rentiohq/shared-frontend/dist/reduxV2/generalLedgerAccount/generalLedgerAccount.types";
import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IPaymentOrder } from "@rentiohq/shared-frontend/dist/types/payment.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import {
  Card,
  MultiStepForm as Form,
} from "@rentiohq/web-shared/dist/components";
import { useNavigate } from "react-router-dom";

const formId = generateFormId();

interface IProps {
  property: IProperty;
  activeContracts?: IContract[];
  endedContracts?: IContract[];
  generalLedgerAccounts?: IGeneralLedgerAccount[];
  paymentOrder?: IPaymentOrder;
  paymentOrders?: IPaymentOrder[];
  hasOpenPaymentRequests?: boolean;
  internalModeEnabled?: boolean;
  shouldUpdateOpenPaymentRequests?: boolean;
}

export const PaymentForm = (props: IProps) => {
  const {
    property,
    paymentOrder,
    hasOpenPaymentRequests,
    shouldUpdateOpenPaymentRequests,
    activeContracts,
    endedContracts,
    generalLedgerAccounts,
    paymentOrders,
    internalModeEnabled,
  } = props;

  const navigate = useNavigate();

  const { isBroker } = authHooks.useSelf();

  const hasIbanisationForBroker =
    brokerHooks.useBrokerFeature(EBrokerFeature.Ibanisation) || !isBroker;
  const hasBookkeepingForBroker = brokerHooks.useBrokerFeature(
    EBrokerFeature.Bookkeeping,
  );

  const handleSubmit = () => {
    navigate(`/properties/${property.id}/payments`);
  };

  const extraData = {
    activeContracts,
    endedContracts,
    generalLedgerAccounts,
    paymentOrders,
    paymentOrder,
    isBroker,
    property,
    hasOpenPaymentRequests,
    shouldUpdateOpenPaymentRequests,
    ibanisationEnabled: hasIbanisationForBroker,
    bookkeepingEnabled: hasBookkeepingForBroker,
    internalModeEnabled,
  };

  return (
    <Card>
      <Form
        formId={`payment-form-${formId}`}
        schemas={createPaymentSchemas(extraData)}
        withSummary={true}
        activeStep={paymentOrder ? "summary" : undefined}
        isPerformingSubmitActionSelector={isPerformingSubmitActionSelector(
          paymentOrder,
          false,
        )}
        performingSubmitActionErrorSelector={performingSubmitActionErrorSelector(
          paymentOrder,
          false,
        )}
        submitActionCreator={(formData: any) => {
          const { id: propertyId } = property;
          const { id: paymentOrderId = undefined } = paymentOrder || {};

          return submitActionCreator(
            extraData,
            propertyId,
            paymentOrderId,
            paymentOrder,
            false,
          )(formData);
        }}
        onSubmit={handleSubmit}
      />
    </Card>
  );
};
